// @flow

import axios from 'axios';
import { Constant, CURRENT_ROOM_NAME } from '../../../webjam/constant';
import { getPublicIp } from '../../../webjam/helper';
import config from '../../config';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2, FEATURE_CUSTOM_REDUX_V3 } from '../../constant';
import { getBaseConfig, getStore } from '../../Utils';
const main_url = config.socket_endpoint;

import {
    SET_ACTIVE_MODAL_ID,
    SET_MENU_STATUS,
    UNSET_CONFERENCE,
    SET_CONFERENCE_JOINED,
    SET_HOST_DATA,
    SHOW_OR_HIDE_ERROR_MODAL,
    SHOW_HIDE_MODERATOR_DISCONNECT,
    SHOW_HIDE_MULTIMODERATOR_DISCONNECT,
    SHOW_TOAST_POPUP,
    Set_VALUE_FOR_AUTOCONNECT,
    SET_USERS_DATA,
    SET_END_ROOM_DATA,
    SET_USER_CONNECTION_STATUS,
    HANDLE_WEBJAM_HOME_CLICK,
    SET_IPADDRESS_VIDEO,
    SET_SHOW_HIDE_STATUS_WEBJAM_MENU,
    SET_INTERNET_STATUS,
    SET_SOCKET_CONNECTION_STATUS,
    SET_DATA,
    SET_NAME,
    SET_JOIN_ROOM_MODAL_STATUS,
    SET_VIDEO_SCREEN_STATUS,
    SET_PROTOCOL,
    CLOSE_VIDEO,
    SET_FCM_TOKEN,
    SET_DEVICE_LIST_DATA,
    API_GET_IPLIST,
    SHOW_API_LOADER,
    HIDE_API_LOADER,
    SET_PUBLIC_IP,
    SET_METRONOME_STATUS,
    SET_BUFFER_STATUS,
    SET_LATENCY_STATUS,
    SET_RECORDING,
    STOP_RECORDING,
    GHOST_LIST,
    SET_ROOM_OR_IP,
    HOST_TAB_DATA,
    CLICK_MAKE_HOST,
    HOST_TAB_RELOAD,
    SHOW_BUFFER_LOADER,
    AUDIO_GHOST,
    GHOST_VOICESYNC,
    CONNECT_AUDIO_GHOST,
    SET_HYBRID_SESSION,
    SET_LOGIN_MODAL,
    SET_USER_IS_LOGIN,
    SET_USER_LOGIN_DATA,
    SET_ROOM_PASS_PROTECT,
    SET_GHOST_RECORDING,
    AUTO_MAKE_HOST,
    CLICK_AUTO_MAKE_HOST,
    SET_WAITING_SCREEN,
    SET_CLOSE_AVATAR_POP,
    SET_HOST_REFRESH,
    SET_HOST_REFRESH_TIMER,
    SET_IS_CLAIM_CLICKED,
    SET_RECORDING_LIST,
    SET_RECORDING_LIST_SHOW,
    SET_AUDIO_GHOST_CONNECT,
    SET_CHAT_RECORDING_FILES,
    SET_CHAT_RECORDING_FILES_VISIBILITY,
    SET_LOBBY_STATUS,
    SET_MUSIC_MODE_VOLUME,
    SET_APP_URLS,
    SET_STEM_RECORDING,
    SET_STEM_RECORDING_URL,
    SET_DELAY_PANNING,
    SET_DEVICES_USERS,
    SET_PREV_PANNING,
    SET_HOST_WAIT_INIT,
    SET_AUDIO_CHANNEL,
    SET_DECODED_DATA,
    SET_AUTH_VERIFY_TOKEN,
    SET_ORGANIZATION_LIST,
    SET_ORGANIZATION,
    SET_TEACHER_WILL_WAIT,
    SET_STUDENT_MODERATOR,
    SET_ROOM_USERS,
    SET_STUDENT_SECOND_MODERATOR,
    SET_RECORDING_TYPE,
    HOST_TAB_DATA_MAIN,
    SET_THIRD_PARTY_HOST_TAB_DATA,
    SET_PREJOIN_INFO_CODE,
    SET_IS_LOGOUT,
    SET_WAITING_SCREEN_STATUS
} from './actionType';

/**
 * Action to set the ID of the active modal (or undefined if needs to be hidden).
 *
 * @param {string} activeModalId - The new modal ID or undefined.
 * @param {Object} modalProps - The props to pass to the modal.
 * @returns {{
 *     activeModalId: string,
 *     type: SET_ACTIVE_MODAL_ID
 * }}
 */
export function setActiveModalId(activeModalId: ?string, modalProps: Object = {}) {
    return {
        activeModalId,
        modalProps,
        type: SET_ACTIVE_MODAL_ID
    };
}

export function setMenuStatus(data: Object = {}) {
    return {
        data,
        type: SET_MENU_STATUS
    };
}

//hide message from conference page
export function unsetConference(data: Object = {}) {
    return {
        data,
        type: UNSET_CONFERENCE
    };
}

//conference joined
export function setConferenceJoined(data: Object = {}) {
    return {
        data,
        type: SET_CONFERENCE_JOINED
    };
}

export function setUsersData(usersData: Object = {}) {
    if (usersData) {
        if (usersData != null && typeof usersData == "object") {
            if (usersData.myName != undefined) {
                if (usersData.myName.toLowerCase().indexOf("sor") != -1) {
                    usersData.myName = "user";
                }
            } else {
                if (!usersData.myName.length) {
                    let { local } = getStore("features/base/participants");
                    usersData.myName = "user";
                }
            }
        }
    }
    return {
        usersData,
        type: SET_USERS_DATA
    };
}

export function saveHostResponse(hostData: Object = {}) {
    return {
        hostData,
        type: SET_HOST_DATA
    };
}
export function saveRoomEndValue(data: Object = {}) {
    return {
        data,
        type: SET_END_ROOM_DATA
    };
}

export function setUserConnectionStatus(data: Object = {}) {
    return {
        data,
        type: SET_USER_CONNECTION_STATUS
    };
}

export function handleWebJamHomeButtonClick(data: Object = {}) {
    return {
        data,
        type: HANDLE_WEBJAM_HOME_CLICK
    };
}
export function setIpAddressForVideoScreen(data: Object = {}) {
    return {
        data,
        type: SET_IPADDRESS_VIDEO
    };
}
export function setShowHideStatusWebJamMenu(data: Object = {}) {
    return {
        data,
        type: SET_SHOW_HIDE_STATUS_WEBJAM_MENU
    };
}
export function setAutoConnectStatus(data: Object = {}) {
    return {
        data,
        type: Set_VALUE_FOR_AUTOCONNECT
    };
}
export function setInternetStatus(data: Object = {}) {
    return {
        data,
        type: SET_INTERNET_STATUS
    };
}
export function setSocketConnectionStatus(data: Object = {}) {
    return {
        data,
        type: SET_SOCKET_CONNECTION_STATUS
    };
}
export function setData(data: Object = {}) {
    return {
        data,
        type: SET_DATA
    };
}
export function setName(data: Object = {}) {
    return {
        data,
        type: SET_NAME
    };
}

export function setJoinRoomModalStatus(data: Object = {}) {
    return {
        data,
        type: SET_JOIN_ROOM_MODAL_STATUS
    };
}
export function setVideoScreenStatus(data: Object = {}) {
    return {
        data,
        type: SET_VIDEO_SCREEN_STATUS
    };
}
export function setProtocol(data: Object = {}) {
    return {
        data,
        type: SET_PROTOCOL
    };
}
export function showHideCustomModal(data: Object = {}) {
    return {
        data,
        type: SHOW_OR_HIDE_ERROR_MODAL
    };
}
export function showHideModeratorDisconnect(data: Object = {}) {
    return {
        data,
        type: SHOW_HIDE_MODERATOR_DISCONNECT
    };
}
export function showHideMultiModeratorDisconnect(data: Object = {}) {
    return {
        data,
        type: SHOW_HIDE_MULTIMODERATOR_DISCONNECT
    };
}

export function showToastPopup(data: Object = {}) {
    return {
        data,
        type: SHOW_TOAST_POPUP
    };
}

export function closeVideoCall(data: Object = {}) {
    return {
        data,
        type: CLOSE_VIDEO,
    };
}
export function setFcmToken(data: Object = {}) {
    return {
        data,
        type: SET_FCM_TOKEN
    };
}

export function saveDeviceListBase(data: Object) {
    return {
        data,
        type: SET_DEVICE_LIST_DATA
    }
}

export function setDeviceListData(data: Object = {}) {
    return async (dispatch) => {
        dispatch(saveDeviceListBase({ data }))
        // if (data.hasOwnProperty("deviceList")) {
        //     if (data.deviceList.length) {
        //         try {
        //             let device_ip = await getPublicIp()
        //             let getAvailDevice = await axios({
        //                 method: 'POST',
        //                 url: main_url + "/common/get-device-list-status",
        //                 data: {
        //                     deviceList: data.deviceList,
        //                     device_ip
        //                 }
        //             })
        //             if (getAvailDevice) {
        //                 if (getAvailDevice?.data.status) {
        //                     if (getAvailDevice.data.data) {
        //                         if (getAvailDevice.data.data.length) {
        //                             let filteredDevice = getAvailDevice.data.data.map(e => e.device_id)
        //                             dispatch(saveDeviceListBase({ deviceList: filteredDevice }))
        //                         }
        //                     }
        //                 }
        //             }
        //         } catch (e) {
        //         }
        //     }
        // }
    }
}

export function showApiLoader(data: Object = {}) {
    return (dispatch) => {
        let willShowLoader = true;
        let { showDevicePreConnection } = getStore(FEATURE_CUSTOM_REDUX_V3)

        if (showDevicePreConnection) {
            willShowLoader = false;
        }

        if (willShowLoader) {
            dispatch(showApiLoaderSub(data));
        }
    }
};

export function showApiLoaderSub(data: Object = {}) {
    return {
        type: SHOW_API_LOADER,
        data
    }
};

export function hideApiLoader(data: Object = {}) {
    return (dispatch, getState) => {
        let willHideLoader = true;

        let { isBufferChange } = getState()[FEATURE_CUSTOM_REDUX_V2];
        if (isBufferChange) {
            willHideLoader = false;
        }

        let { isEventRequestingLoader, serverConnectRehit, isNatType } = getStore(FEATURE_CUSTOM_REDUX_V3);
        if (isEventRequestingLoader == "bufferDelayChange") {
            willHideLoader = false;
        }

        if (serverConnectRehit) {
            willHideLoader = false;
        }

        if (isNatType.type3) {
            willHideLoader = false;
        }


        let { textMessage } = getState()[FEATURE_CUSTOM_REDUX];
        if (textMessage != null) {
            console.log("textMessage AA ", textMessage)
            let message = textMessage?.textMessage
            console.log("textMessage BB ", message, "data ", data)

            if (message && message == "fetchSubscription") {
                if (!data.hasOwnProperty("removeIntention")) {
                    willHideLoader = false;
                }
            }
        }
        if (willHideLoader) {
            dispatch(hideApiLoaderSub())
        }
    }
};

export function hideApiLoaderSub(data: Object = {}) {
    return {
        type: HIDE_API_LOADER,
    }
};

export function setPublicIp(data: Object = {}) {
    return {
        data,
        type: SET_PUBLIC_IP,
    }
};

export function setMetronomeStatus(data: Object = {}) {
    return {
        data,
        type: SET_METRONOME_STATUS,
    }
};

export function setRecording(data: Object = {}) {
    if (data.recIpAddress != undefined && data.recTimeStamp != undefined) {
        if (data.isStored == undefined) {
            sessionStorage.setItem("rec_session", JSON.stringify({
                t: Math.ceil(new Date().getTime() / 1000),
                location: window.location.origin,
                recIpAddress: data.recIpAddress,
                recTimeStamp: data.recTimeStamp,
                roomName: CURRENT_ROOM_NAME
            }))
        } else {
            sessionStorage.removeItem("rec_session")
        }
    }

    return {
        data,
        type: SET_RECORDING,
    }
};

export function stopRecording(data: Object = {}) {
    return {
        data,
        type: STOP_RECORDING,
    }
};

export function ghostList(data: Object = {}) {
    return {
        data,
        type: GHOST_LIST,
    }
};

export function setRoomorIpAddress(data: Object = {}, setFrom: String) {
    console.log("setRoomorIpAddress =>", data, setFrom)
    return {
        data,
        type: SET_ROOM_OR_IP,
    }
};

export function setHostTabData(data: Object = {}) {
    return {
        data,
        type: HOST_TAB_DATA,
    }
};

export function setHostTabDataMain(data: Object = {}) {
    return (dispatch, getState) => {
        let { thirdPartyUser } = getState()[FEATURE_CUSTOM_REDUX];
        let hostData = data;
        let thirdPIndex = -1;
        if (data.users != undefined && Object.keys(thirdPartyUser).length) {
            let index = -1;
            for (let i = 0; i < data.users.length; i++) {
                if (data.users[i].isRecommended == true) {
                    let userPing = data.users[i].sumPing.split('ms');
                    userPing = Number(userPing[0]);
                    let thirdPartyPing;
                    if (getBaseConfig("showAllThirdPartyServers")) {
                        thirdPartyPing = thirdPartyUser.servers.filter(e => e.isLowest == true)
                        thirdPartyPing = thirdPartyPing[0].sumPing.split('ms');
                        thirdPartyPing = Number(thirdPartyPing[0]);
                    } else {
                        thirdPartyPing = thirdPartyUser.sumPing.split('ms');
                        thirdPartyPing = Number(thirdPartyPing[0]);
                    }
                    if ((userPing > thirdPartyPing) || (userPing == thirdPartyPing)) {
                        let willBreak = false;
                        if (data.users[i].name?.toLowerCase() == "mixer") {
                            if (Math.abs(userPing - thirdPartyPing) > 5) {
                                willBreak = true;
                            }
                        } else {
                            willBreak = true;
                        }
                        if (willBreak) {
                            index = i;
                            break;
                        }
                    }
                }
            }

            thirdPIndex = hostData?.users.length;
            if (index != -1) {
                data.users[index].isRecommended = false;
                if (getBaseConfig("showAllThirdPartyServers")) {
                    let thirdPartyArray = thirdPartyUser.servers;
                    for (let t = 0; t < thirdPartyArray.length; t++) {
                        thirdPartyArray[t] = Object.assign({
                            isRecommended: thirdPartyArray[t].isLowest
                        }, thirdPartyArray[t])
                        hostData?.users.push(thirdPartyArray[t])
                    }
                } else {
                    thirdPartyUser = Object.assign({
                        isRecommended: true
                    }, thirdPartyUser)
                    hostData?.users.push(thirdPartyUser)
                }
            }
            else if (index == -1) {
                if (getBaseConfig("showAllThirdPartyServers")) {
                    let thirdPartyArray = thirdPartyUser.servers;
                    for (let t = 0; t < thirdPartyArray.length; t++) {
                        let checkselfHostRec = data.users.find(o => o.isRecommended == true)
                        if (checkselfHostRec) {
                            thirdPartyArray[t] = Object.assign({
                                isRecommended: false
                            }, thirdPartyArray[t])
                        } else {
                            thirdPartyArray[t] = Object.assign({
                                isRecommended: thirdPartyArray[t].isLowest
                            }, thirdPartyArray[t])
                        }
                        hostData?.users.push(thirdPartyArray[t])
                    }
                } else {
                    thirdPartyUser = Object.assign({
                        isRecommended: true
                    }, thirdPartyUser)
                    hostData?.users.push(thirdPartyUser)
                }
            }

            let isRec = hostData?.users?.find(o => o.isRecommended == true)
            if (!isRec || isRec == undefined) {
                if (thirdPIndex != -1) {
                    hostData.users[thirdPIndex].isRecommended = true;
                }
            }

            // RTA_SINGLE_ROOM
            let roomUrl = CURRENT_ROOM_NAME;
            let noChangedRoomName = getBaseConfig('noChangedRoomName')
            if (noChangedRoomName == true) {
                let roomorIpAddress = getStore(FEATURE_CUSTOM_REDUX).roomorIpAddress
                roomUrl = roomorIpAddress
                if (roomUrl.includes(":")) {
                    roomUrl = roomUrl.split(':');
                    roomUrl = roomUrl[0]
                }
            } else {
                if (roomUrl.includes("_")) {
                    roomUrl = roomUrl.split('_');
                    roomUrl = roomUrl[0]
                }
            }

            try {
                let user_data = hostData.users.filter(e => e.isThirdParty && e.thirdParty == roomUrl);
                let filter_third_party = hostData.users.filter(e => e.isThirdParty && e.thirdParty != roomUrl);
                let filter_mixer = hostData.users.filter(e => e.name == 'Mixer');

                if (user_data && user_data.length) {
                    hostData.users = hostData.users.filter(e => e?.name?.toLowerCase() != "mixer");
                } else if (filter_third_party && filter_third_party.length && filter_mixer && filter_mixer.length) {
                    if (filter_third_party[0].city == filter_mixer[0].city) {
                        hostData.users = hostData.users.filter(e => e?.thirdParty == filter_third_party?.thirdParty);
                    }
                }
            } catch (e) {
                console.log('setHostTabDataMain error =>', e)
            }

            console.log("hostData final 1 =>", hostData)

            // START : If current and recommended host is third party and avg ping is same, then current host will be recommended
            let curIpHost = hostData.users.filter(e => e.isThirdParty && e.isHost);
            curIpHost = curIpHost[0]

            let recIpHost = hostData.users.filter(e => e.isThirdParty && e.isRecommended);
            recIpHost = recIpHost[0]

            if (curIpHost && recIpHost) {
                let curIpHostPing = curIpHost.sumPing.split('ms');
                curIpHostPing = Number(curIpHostPing[0]);

                let recIpHostPing = recIpHost.sumPing.split('ms');
                recIpHostPing = Number(recIpHostPing[0]);

                let ipHostPingDiff = curIpHostPing - recIpHostPing

                if (curIpHostPing == recIpHostPing || ipHostPingDiff < 5) {
                    for (let i = 0; i < hostData.users.length; i++) {
                        if (hostData.users[i].city == recIpHost.city) {
                            data.users[i].isRecommended = false
                        }

                        if (hostData.users[i].city == curIpHost.city) {
                            data.users[i].isRecommended = true
                        }
                    }
                }
            }
            // END : If current and recommended host is third party and avg ping is same, then current host will be recommended

            console.log("hostData final 2 =>", hostData)
        }
        dispatch(setHostTabData(hostData))
    }
};

export function setThirdPartyHostTabData(thirdPartyUser: Object) {
    return {
        thirdPartyUser,
        type: SET_THIRD_PARTY_HOST_TAB_DATA,
    }
};

export function setclickMakeHost(data: Object = {}) {
    return {
        data,
        type: CLICK_MAKE_HOST,
    }
};

export function setHostTabReload(data: Object = {}) {
    return {
        data,
        type: HOST_TAB_RELOAD,
    }
};

export function getipListFromApi() {
    return function (dispatch) {
        return fetch(Constant.App.IpListUrl).
            then((response) => response.json())
            .then(data => {
                dispatch({
                    type: API_GET_IPLIST,
                    data
                });
            });
    };
}

export function setBufferValue(data: Object = {}) {
    return {
        data,
        type: SET_BUFFER_STATUS
    };
}

export function setLatencyStatus(data: Object = {}) {
    return {
        data,
        type: SET_LATENCY_STATUS
    };
}

export function setBufferLoader(data: Object = {}) {
    return {
        type: SHOW_BUFFER_LOADER,
        data
    }
};

export function setAudioGhost(data: Object = {}) {
    return {
        type: AUDIO_GHOST,
        data
    }
};

export function setGhostVoiceSync(data: Object = {}) {
    return {
        type: GHOST_VOICESYNC,
        data
    }
};

export function connectAudioGhost(data: Object = {}) {
    return {
        type: CONNECT_AUDIO_GHOST,
        data
    }
};

export function setHybridSession(isHybridSession: Boolean, from: String) {
    return {
        type: SET_HYBRID_SESSION,
        isHybridSession
    }
};

export function setLoginModal(dashboardLogin: Boolean) {
    return {
        type: SET_LOGIN_MODAL,
        dashboardLogin
    }
};

export function setUserIsLogin(isUserLogin: Boolean) {
    if (isUserLogin) {
        sessionStorage.setItem("isUserLogin_", true)
    } else {
        sessionStorage.removeItem("isUserLogin_")
    }

    return {
        type: SET_USER_IS_LOGIN,
        isUserLogin
    }
};

export function setUserLoginData(userLoginData: any, additional: any = null) {
    return {
        type: SET_USER_LOGIN_DATA,
        userLoginData
    }
};

export function setRoomPassProtect(roomPassProtectModal: Boolean) {
    return {
        type: SET_ROOM_PASS_PROTECT,
        roomPassProtectModal
    }
};

export function setGhostUserId(ghostUserId: Boolean) {
    return {
        type: SET_GHOST_RECORDING,
        ghostUserId
    }
};

export function setAutoMakeHost(data: Object = {}) {
    return {
        type: AUTO_MAKE_HOST,
        data
    };
}

export function clickAutoMakeHost(data: Object = {}, clickAutoMakeHostSetFrom: String = '') {
    return {
        type: CLICK_AUTO_MAKE_HOST,
        data
    };
}

export function setWaitingScreen(isWaiting: Boolean, from = "") {
    console.log("set waiting screen from ", from)
    return {
        type: SET_WAITING_SCREEN,
        isWaiting
    };
}

export function setWaitingScreenStatus(isWaitingScreen: Boolean) {
    return {
        type: SET_WAITING_SCREEN_STATUS,
        isWaitingScreen
    };
}

export function setAvatarPop(avatarPopShow: Boolean) {
    return {
        type: SET_CLOSE_AVATAR_POP,
        avatarPopShow
    };
}

export function setHostRefresh(hostRefresh: Boolean) {
    return {
        type: SET_HOST_REFRESH,
        hostRefresh
    };
}

export function setHostRefreshTimer(hostRefreshTimer: Boolean) {
    return {
        type: SET_HOST_REFRESH_TIMER,
        hostRefreshTimer
    };
}

export function setIsClaimClicked(isClaimClicked: Boolean) {
    return {
        type: SET_IS_CLAIM_CLICKED,
        isClaimClicked
    };
}

// set flag if audio ghost connected or disconnected
export function setAudioGhostConnect(isAudioGhostLobby: Boolean, type = '') {
    return {
        type: SET_AUDIO_GHOST_CONNECT,
        isAudioGhostLobby
    };
}

export function setChatRecordingFiles(chatFiles: any) {
    return {
        type: SET_CHAT_RECORDING_FILES,
        chatFiles
    };
}

export function setChatRecordingFilesVisible(chatFilesVisible: Boolean) {
    return {
        type: SET_CHAT_RECORDING_FILES_VISIBILITY,
        chatFilesVisible
    };
}

// set lobby status if lobby is intentionally enabled/disabled by admin or other user,
// in case while connecting audio ghost user, lobby is enable/disable.
// after that lobby status should be same as it was previous
export function setLobbyStatus(lobbyStatus: Boolean) {
    return {
        type: SET_LOBBY_STATUS,
        lobbyStatus
    };
}

export function setAppBaseUrls(appBaseUrls: any) {
    return {
        type: SET_APP_URLS,
        appBaseUrls
    }
};

export function setStemRecording(stemRecording: Boolean, loc = '') {
    return {
        type: SET_STEM_RECORDING,
        stemRecording
    }
};
export function setStemRecordingUrl(stemRecordingUrl: any) {
    return {
        type: SET_STEM_RECORDING_URL,
        stemRecordingUrl
    }
};
export function setDelayPanning(delayPanning: any, additionalDelay: any) {
    return {
        type: SET_DELAY_PANNING,
        delayPanning,
        additionalDelay
    }
};
export function setPrevPanning(prevPanning: Array) {
    return {
        type: SET_PREV_PANNING,
        prevPanning
    }
};
export function setDeviceUsers(devicesUsers: any) {
    return {
        type: SET_DEVICES_USERS,
        devicesUsers
    }
};

export function setHostInitWait(isHostInitWaiting: boolean) {
    return {
        type: SET_HOST_WAIT_INIT,
        isHostInitWaiting
    }
};

// audioChannelSt means saves in storage (can be conflict with local audioChannel and store audioChannel name)
// export function setAudioChannel(audioChannelSt: any, additionalAudioChannel: any) {
//     return {
//         type: SET_AUDIO_CHANNEL,
//         audioChannelSt
//         // additionalAudioChannel
//     }
// };

// Duet
export function setDecodedData(tokenDecodedData: any) {
    if (tokenDecodedData) {
        if (tokenDecodedData.hasOwnProperty("room")) {
            tokenDecodedData.roomName = tokenDecodedData.room;
        }
    }
    return {
        type: SET_DECODED_DATA,
        tokenDecodedData
    }
};
export function setAuthVerify(authVerifyToken: any) {
    return {
        type: SET_AUTH_VERIFY_TOKEN,
        authVerifyToken
    }
};

// export function setOrganizationList(organizationList: array) {
//     return {
//         type: SET_ORGANIZATION_LIST,
//         organizationList
//     }
// };

// export function setOrganization(authOrganization: any) {
//     return {
//         type: SET_ORGANIZATION,
//         authOrganization
//     }
// };

export function setTeacherWillWait(teacherWaitTimer: any) {
    return {
        type: SET_TEACHER_WILL_WAIT,
        teacherWaitTimer
    }
};

export function setStudentGrantModerator(studentGrantModerator: any) {
    return {
        type: SET_STUDENT_MODERATOR,
        studentGrantModerator
    }
};

export function setRoomUsers(authRoomUsers: Array) {
    return {
        type: SET_ROOM_USERS,
        authRoomUsers
    }
};

export function setStudentSecondModerator(secondModerator: Boolean) {
    return {
        type: SET_STUDENT_SECOND_MODERATOR,
        secondModerator
    }
};

export function setPrejoinDeviceCode(prejoinDeviceCode: any) {
    return {
        type: SET_PREJOIN_INFO_CODE,
        prejoinDeviceCode
    }
};

// export function setDefaultRecordingType(defaultRecordingType: any) {
//     return {
//         type: SET_RECORDING_TYPE,
//         defaultRecordingType
//     }
// }

export function setLogoutType(isLogout: any) {
    return {
        type: SET_IS_LOGOUT,
        isLogout
    }
}